import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;

  switch(action.type) {
    case types.SAVE_DATA_SUCCESS:
      return { ...state, response };
    case types.SAVE_DATA_ERROR:
      return { ...state, response };
    default:
      return state;
  }
};